import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import includes from 'lodash/includes';

import { ActionMenu, ActionMenuGroup } from './ActionMenuContainers';
import Icon from './Icon';
import ActionMenuItem from './ActionMenuItem';
import OverlayTrigger from './OverlayTrigger';
import './stylesheets/FilterSelector.scss';

export default class FilterSelector extends React.Component {

  constructor(props) {
    super(props);

    this.state = { selectedFilters: props.selectedFilters };

    this.renderFilter = this.renderFilter.bind(this);
    this.onFilterClick = this.onFilterClick.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
  }

  onFilterClick(filter, value) {
    const { onFilter } = this.props;

    return () => {
      const { selectedFilters } = this.state;
      let values = selectedFilters[filter.key] || [];

      const valueIndex = values.findIndex(element => element.key === value.key);

      // if the valueIndex is greater than 0 it already exists in the array and
      // we need to remove it, otherwise add the value to the array.
      if (valueIndex >= 0) {
        values.splice(valueIndex, 1);
      } else {
        values = [...values, value];
      }

      const newSelectedFilters = { ...selectedFilters };

      // Remove the filter entirely when there is no value selected.
      if (values.length === 0) {
        delete newSelectedFilters[filter.key];
      } else {
        newSelectedFilters[filter.key] = values;
      }

      onFilter(newSelectedFilters);
      this.setState({ selectedFilters: newSelectedFilters });
    };
  }

  clearFilters() {
    const { onFilter } = this.props;

    onFilter({}, true);
    this.setState({ selectedFilters: {} });
  }

  renderFilter(filter, index) {
    const { selectedFilters } = this.state;

    let filterLabel = filter.label;
    const selectedValues = selectedFilters[filter.key];
    let selectedValueKeys = [];

    if (selectedValues) {
      filterLabel = selectedValues.map(v => v.label).join(', ');
      selectedValueKeys = selectedValues.map(v => v.key);
    }

    const renderFilterValue = (value, i) => {
      const selected = includes(selectedValueKeys, value.key);
      const classes = { selected, checked: selected };
      if (selected) {
        classes['FilterSelector--selected'] = true;
        return (
          <ActionMenuItem
            key={i}
            onClick={this.onFilterClick(filter, value)}
            className={classNames(classes)}
          >
            { value.label }
            <Icon icon="checkmark" />
          </ActionMenuItem>
        );
      }
      return (
        <ActionMenuItem
          key={i}
          title={value.label}
          className={classNames(classes)}
          onClick={this.onFilterClick(filter, value)}
        />
      );
    };

    const actionMenu = (
      <ActionMenu>
        <ActionMenuGroup>
          { filter.values.map(renderFilterValue) }
        </ActionMenuGroup>
      </ActionMenu>
    );

    const labelClassName = classNames({ 'filter-dropdown': true, active: !!selectedValues });

    return (
      <OverlayTrigger key={index} trigger="click" placement="bottom" overlay={actionMenu}>
        <span className={labelClassName}>{ filterLabel }</span>
      </OverlayTrigger>
    );
  }

  renderClearFilter() {
    return <Icon icon="close" className="clear-filters" onClick={this.clearFilters} />;
  }

  render() {
    const { className, filters, selectedFilters } = this.props;
    const classes = { loc: true, 'filter-selector': true };

    const noSelectedFilters = Object.keys(selectedFilters).length === 0;

    return (
      <div className={classNames(classes, className)}>
        <strong>Filter by</strong>
        { filters.map(this.renderFilter) }
        { noSelectedFilters ? null : this.renderClearFilter() }
      </div>
    );
  }
}

FilterSelector.propTypes = {
  /** An array of objects describing fields and values to filter on */
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      key: PropTypes.string,
      values: PropTypes.array
    })
  ).isRequired,
  /** Object with names of column as key and selected filters as values */
  selectedFilters: PropTypes.object, // eslint-disable-line
  /** Function called when a filter is added/removed */
  onFilter: PropTypes.func.isRequired,
  /** Additional className to customize styles */
  className: PropTypes.string
};

FilterSelector.defaultProps = {
  selectedFilters: {}
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/FilterSelector.jsx